// extracted by mini-css-extract-plugin
export var boxItems = "_ac-1";
export var boxItemsLg = "_ac-2";
export var button = "_ac-7";
export var buttonHoverless = "_ac-9";
export var buttonLg = "_ac-8";
export var filterGroupBox = "_ac-0";
export var icon = "_ac-3";
export var iconSecondary = "_ac-6";
export var iconWrapper = "_ac-4";
export var iconWrapperLg = "_ac-5";
export var truncatedLabel = "_ac-a";